import { toast } from 'react-toastify';
import appApi from '../../../../../../../api/app-api';
import { displayErrorText } from '../../../../../../../api/errors/api-error-codes';

export const createCrmContactOperation = async (
  accountId: number,
  payload: {
    isPrimary: boolean;
    firstName: string;
    lastName: string;
    idNumber: string | null;
    email: string | null;
    phone: string | null;
    address: string | null;
    notes: string | null;
  },
  setLoading: (loading: boolean) => any,
  onSuccess: () => void,
) => {
  try {
    setLoading(true);

    const res = await appApi.createCrmContact(accountId, {
      accountId,
      isPrimary: payload.isPrimary,
      firstName: payload.firstName,
      lastName: payload.lastName,
      idNumber: payload.idNumber,
      email: payload.email,
      phone: payload.phone,
      address: payload.address,
      notes: payload.notes,
      convertedToUserId: null,
    });

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    toast.success('איש קשר נוצר בהצלחה');
    setLoading(false);
    onSuccess();
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
